// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3LUfa","noInteraction":"EventWrapper_noInteraction__1N0Hi"};